<script lang="ts">
	interface Props {
		id?: string
		checked?: boolean
		label?: string
		class?: string
	}

	let { id, checked = $bindable(), label = '', class: className }: Props = $props()
</script>

<label class="{className} tw:ps-3 tw:pt-6">
	<input
		{id}
		type="checkbox"
		bind:checked
		class="tw:accent-plum tw:focus:ring-2 tw:focus:ring-lilac tw:me-1" />
	{label}
</label>
